import Flex from '@deprecated-ui/common/Flex';
import { useMemo } from 'react';
import PausePlay from './PausePlay'; // Implemented on next phase
import { ActionControlWrapper } from './styled';
import AdvancedFilter from './AdvancedFilter';
import StocksFilter from './StocksFilter';
import { useFilterStore } from '../store';
import { StockFilterTypeEnum } from '../types';

interface ActionControlProps {
  isMarketOpen: boolean;
  hideStockFilter?: boolean;
  playAlignRight?: boolean;
}

const ActionControl = ({
  isMarketOpen,
  hideStockFilter = false,
  playAlignRight = false,
}: ActionControlProps) => {
  const stockFilter = useFilterStore((s) => s.stocksFilter);

  const isLeftPlayVisible = useMemo(
    () => isMarketOpen && !playAlignRight,
    [isMarketOpen, playAlignRight],
  );
  const isRightPlayVisible = useMemo(
    () => isMarketOpen && playAlignRight,
    [isMarketOpen, playAlignRight],
  );

  const showAdvancedFilter = useMemo(() => {
    if (isMarketOpen) return true;
    if (
      !isMarketOpen &&
      stockFilter.type === StockFilterTypeEnum.Custom &&
      stockFilter.selected.length === 1
    ) {
      return true;
    }
    return false;
  }, [stockFilter, isMarketOpen]);

  return (
    <ActionControlWrapper>
      {isLeftPlayVisible && <PausePlay />}
      <div />
      <Flex style={{ gap: 8 }} justify="end">
        {isRightPlayVisible && <PausePlay />}
        {!hideStockFilter && <StocksFilter isMarketOpen={isMarketOpen} />}
        {showAdvancedFilter && <AdvancedFilter isMarketOpen={isMarketOpen} />}
      </Flex>
    </ActionControlWrapper>
  );
};

export default ActionControl;
